export default __webpack_public_path__ + "static/Suzie-03901ea1c124a07f10e3558ba751eaaa.png";